import type * as Types from '../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type UpdateRegistryPageContainerPhotoMutationVariables = Types.Exact<{
  payload: Types.PageContainerUpdatePayload;
}>;

export type UpdateRegistryPageContainerPhotoMutation = {
  __typename?: 'Mutation';
  updatePageContainer: {
    __typename?: 'PageContainer';
    id: string;
    mainPhotoV2?: { __typename?: 'DefaultPagePhoto'; id: string; url: string } | { __typename?: 'Photo'; id: string; url: string } | null;
  };
};

export const UpdateRegistryPageContainerPhotoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRegistryPageContainerPhoto' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PageContainerUpdatePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePageContainer' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainPhotoV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateRegistryPageContainerPhotoMutationFn = Apollo.MutationFunction<UpdateRegistryPageContainerPhotoMutation, UpdateRegistryPageContainerPhotoMutationVariables>;

/**
 * __useUpdateRegistryPageContainerPhotoMutation__
 *
 * To run a mutation, you first call `useUpdateRegistryPageContainerPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistryPageContainerPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegistryPageContainerPhotoMutation, { data, loading, error }] = useUpdateRegistryPageContainerPhotoMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateRegistryPageContainerPhotoMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRegistryPageContainerPhotoMutation, UpdateRegistryPageContainerPhotoMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateRegistryPageContainerPhotoMutation, UpdateRegistryPageContainerPhotoMutationVariables>(
    UpdateRegistryPageContainerPhotoDocument,
    baseOptions,
  );
}
export type UpdateRegistryPageContainerPhotoMutationHookResult = ReturnType<typeof useUpdateRegistryPageContainerPhotoMutation>;
export type UpdateRegistryPageContainerPhotoMutationResult = Apollo.MutationResult<UpdateRegistryPageContainerPhotoMutation>;
export type UpdateRegistryPageContainerPhotoMutationOptions = Apollo.BaseMutationOptions<
  UpdateRegistryPageContainerPhotoMutation,
  UpdateRegistryPageContainerPhotoMutationVariables
>;
